// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from 'D:/svn/ZY_deploy/老年大学/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": require('@/layouts/blank').default,
    "routes": [
      {
        "path": "/auth",
        "component": require('@/pages/Auth.jsx').default,
        "title": "微信认证",
        "exact": true
      },
      {
        "path": "/nav",
        "component": require('@/layouts/basic').default,
        "routes": [
          {
            "path": "/nav/home",
            "component": require('@/pages/home').default,
            "title": "幸福课堂",
            "exact": true
          },
          {
            "path": "/nav/program",
            "component": require('@/pages/program').default,
            "title": "幸福栏目",
            "exact": true
          },
          {
            "path": "/nav/myself",
            "component": require('@/pages/myself').default,
            "title": "我的",
            "exact": true
          }
        ]
      },
      {
        "path": "/home/courseList",
        "component": require('@/pages/home/courseList').default,
        "exact": true
      },
      {
        "path": "/home/memberList",
        "component": require('@/pages/home/memberList').default,
        "title": "会员专享",
        "exact": true
      },
      {
        "path": "/home/category",
        "component": require('@/pages/home/category').default,
        "title": "全部分类",
        "exact": true
      },
      {
        "path": "/home/search",
        "component": require('@/pages/home/search').default,
        "title": "搜索",
        "exact": true
      },
      {
        "path": "/program/search",
        "component": require('@/pages/program/search').default,
        "title": "搜索",
        "exact": true
      },
      {
        "path": "/home/store",
        "component": require('@/pages/home/store').default,
        "title": "养老服务中心",
        "exact": true
      },
      {
        "path": "/home/store/selectProvince",
        "component": require('@/pages/home/store/selectProvince').default,
        "title": "选择省份",
        "exact": true
      },
      {
        "path": "/home/store/selectCity",
        "component": require('@/pages/home/store/selectCity').default,
        "title": "选择城市",
        "exact": true
      },
      {
        "path": "/home/courseDetail",
        "component": require('@/pages/home/courseDetail').default,
        "exact": true
      },
      {
        "path": "/home/courseDetail/commentDetail",
        "component": require('@/pages/home/courseDetail/commentDetail').default,
        "title": "评论详情",
        "exact": true
      },
      {
        "path": "/home/showContent",
        "component": require('@/pages/home/showContent').default,
        "exact": true
      },
      {
        "path": "/myself/courseList",
        "component": require('@/pages/myself/courseList').default,
        "exact": true
      },
      {
        "path": "/myself/myPoint",
        "component": require('@/pages/myself/myPoint').default,
        "title": "我的积分",
        "exact": true
      },
      {
        "path": "/myself/bindCard",
        "component": require('@/pages/myself/bindCard').default,
        "title": "绑定幸福卡",
        "exact": true
      },
      {
        "path": "/myself/myFiruit",
        "component": require('@/pages/myself/myFiruit').default,
        "title": "我的果实",
        "exact": true
      },
      {
        "path": "/myself/replyMe",
        "component": require('@/pages/myself/replyMe').default,
        "title": "回复我的",
        "exact": true
      },
      {
        "path": "/myself/likeMe",
        "component": require('@/pages/myself/likeMe').default,
        "title": "收到的赞",
        "exact": true
      },
      {
        "path": "/myself/message",
        "component": require('@/pages/myself/message').default,
        "title": "系统通知",
        "exact": true
      },
      {
        "path": "/myself/ranking",
        "component": require('@/pages/myself/ranking').default,
        "title": "积分榜",
        "exact": true
      },
      {
        "path": "/myself/message/detail",
        "component": require('@/pages/myself/message/detail').default,
        "title": "通知详情",
        "exact": true
      },
      {
        "path": "/myself/member",
        "component": require('@/pages/myself/member').default,
        "title": "开通会员",
        "exact": true
      },
      {
        "path": "/myself/collectList",
        "component": require('@/pages/myself/collectList').default,
        "title": "我的收藏",
        "exact": true
      },
      {
        "path": "/myself/browseList",
        "component": require('@/pages/myself/browseList').default,
        "title": "浏览记录",
        "exact": true
      },
      {
        "path": "/myself/programList",
        "component": require('@/pages/myself/programList').default,
        "title": "订阅栏目",
        "exact": true
      },
      {
        "path": "/myself/electronicCard",
        "component": require('@/pages/myself/electronicCard').default,
        "title": "电子卡",
        "exact": true
      },
      {
        "path": "/public/video/account",
        "component": require('@/pages/public/VideoAccount').default,
        "title": "幸福微视",
        "exact": true
      },
      {
        "path": "/program/programDetail",
        "component": require('@/pages/program/programDetail').default,
        "exact": true
      },
      {
        "path": "/program/programDetail/commentDetail",
        "component": require('@/pages/program/programDetail/commentDetail').default,
        "exact": true
      },
      {
        "path": "/program/videoList",
        "component": require('@/pages/program/videoList').default,
        "exact": true
      },
      {
        "title": "幸福直播",
        "path": "/live/home",
        "component": require('@/pages/live/index').default,
        "exact": true
      },
      {
        "title": "积分宝",
        "path": "/live/points",
        "component": require('@/pages/live/points/index').default,
        "exact": true
      },
      {
        "title": "邀请新用户",
        "path": "/invite/:share_id",
        "component": require('@/pages/invite/index').default,
        "exact": true
      },
      {
        "title": "直播详情",
        "path": "/live/detail/:type/:share_id/:id",
        "component": require('@/pages/live/detail/index').default,
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
